import React from 'react';
import { RiMailLine } from 'react-icons/ri';
import { handleChange, getError } from '../../helperFunctions';
import MultiSelectDropdown from '../../../components/MultiSelectDropdown';
import { Divider, Field, TextInput } from '../../../components/UiComponents/Ui';
import { BusinessIdFields, PhoneField } from './SupplierFields';
import { currencies } from '../../../Utlils';

const SupplierDetails = ({
  setSupplierData,
  supplierData,
  formErrors,
  setFormErrors,
}) => {
  const onChange = (path, value) =>
    handleChange(path, value, setSupplierData, setFormErrors, formErrors);

  const handleRemoveRow = (index) => {
    setSupplierData((prev) => ({
      ...prev,
      companyCodes: prev?.companyCodes?.filter((_, i) => i !== index),
    }));
  };

  const handleAddRow = () => {
    setSupplierData((prev) => ({
      ...prev,
      companyCodes: [...(prev?.companyCodes || []), { label: '', value: '' }],
    }));
  };

  const currencyError = getError(['currency'], formErrors)
    ? ['label', 'value', 'symbol']
        .map((k) => getError(['currency', k], formErrors))
        .filter(Boolean)
        .join(' ')
    : '';

  return (
    <div className=" flex flex-col items-center justify-center">
      <div className="w-[80%] space-y-6">
        <Field
          label="Supplier Name"
          required
          error={getError(['name'], formErrors)}
        >
          <TextInput
            placeholder="Enter Supplier Name Here"
            value={supplierData?.supplierName || ''}
            error={getError(['supplierName'], formErrors)}
            onChange={(e) => onChange(['supplierName'], e.target.value)}
          />
        </Field>

        <Field
          label="Supplier Email"
          required
          error={getError(['email'], formErrors)}
        >
          <TextInput
            type="email"
            startIcon={<RiMailLine size={16} className="text-gray-500" />}
            placeholder="Enter Supplier Email Here"
            value={supplierData?.email || ''}
            error={getError(['email'], formErrors)}
            onChange={(e) => onChange(['email'], e.target.value)}
          />
        </Field>

        <PhoneField
          supplierData={supplierData}
          onChange={onChange}
          formErrors={formErrors}
        />

        <Field label="Default Currency" required error={currencyError}>
          <MultiSelectDropdown
            search
            options={currencies}
            dropdownText="Select Default Currency"
            selected={[
              {
                label: supplierData?.currency?.label || '',
                value: supplierData?.currency?.value || '',
              },
            ]}
            setSelected={(e) => {
              const v = e;
              onChange(['currency'], {
                label: v?.[0]?.label,
                value: v?.[0]?.value,
                symbol: v?.[0]?.symbol,
              });
            }}
          />
        </Field>

        <BusinessIdFields
          supplierData={supplierData}
          onChange={onChange}
          formErrors={formErrors}
          onAdd={handleAddRow}
          onRemove={handleRemoveRow}
        />

        <div className="space-y-4">
          <h2>Additional Details</h2>
          <Divider />
          <Field
            label="Description"
            error={getError(['description'], formErrors)}
          >
            <TextInput
              multiline
              rows={5}
              placeholder="Enter Description"
              value={supplierData?.description || ''}
              error={getError(['description'], formErrors)}
              onChange={(e) => onChange(['description'], e.target.value)}
            />
          </Field>
        </div>

        <Field
          label="Invoice Prefix"
          error={getError(['invoicePrefix'], formErrors)}
        >
          <TextInput
            placeholder="Enter Invoice Prefix"
            value={supplierData?.invoicePrefix || ''}
            error={getError(['invoicePrefix'], formErrors)}
            onChange={(e) => onChange(['invoicePrefix'], e.target.value)}
          />
        </Field>
      </div>
    </div>
  );
};

export default SupplierDetails;
